import { TableTemplate } from "components/templates/default/table/TableTemplate";
import {
  ReportInventoryCameraRow,
  ReportInventoryRecorderRow,
} from "api/interfaces/reportInterface.interface";
import * as s from "./InventoryStyled";
import BigButton from "components/atoms/buttons/BigButton";
import { ReactComponent as EXPORT_ICON } from "assets/icons/export.svg";
import { ReactComponent as SEND_EMAIL_ICON } from "assets/icons/send.svg";
import * as mediaQuery from "components/MediaQuery";
import {
  StatusLabel,
  StatusName,
  StatusValue,
} from "components/blocks/status/Status";
import { INVENTORY_MENU, TotalCountInterface } from "./InventoryContainer";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import ExportMail from "./export/ExportMail";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { useMenu } from "hook/useMenu";
import { formatNumber } from "utils/functions";
import Tabs from "components/atoms/tabs/Tabs";
import { ExpandableConfig } from "antd/es/table/interface";
import RBACWrapper from "components/blocks/function/RBACWrapper";

type Props = {
  title: string | undefined;
  cameraData: ReportInventoryCameraRow[];
  recorderData: ReportInventoryRecorderRow[];
  cameraColumns: TableColumnsType<ReportInventoryCameraRow>;
  recorderColumns: TableColumnsType<ReportInventoryRecorderRow>;
  currentMenu: INVENTORY_MENU;
  totalDataCount: TotalCountInterface;
  paginationPerPage: number;
  onChange: (step: INVENTORY_MENU) => void;
  excelDownload: () => void;
  excelEmail: () => void;
  onChangePage: (page: number, totalRows: number) => void;
  onClickSearch: ClickSearch;
  reportId: string;
  isExportEmail: boolean;
  onModalExportMail: () => void;
  recorderTablePending: boolean;
  cameraTablePending: boolean;
  selectedAccount: ProfileAccountInfo;
  recorderPaginationInfo: BasePagination;
  cameraPaginationInfo: BasePagination;
  expandableProps: ExpandableConfig<ReportInventoryRecorderRow>;
  AccountAccessModal: JSX.Element | null;
};

export default function InventoryPresenter(props: Props): JSX.Element {
  const { menuNavigation } = useMenu({});

  const menus = [
    {
      label: "Recorders",
      value: "Recorders",
    },
    {
      label: "Cameras",
      value: "Cameras",
    },
  ];

  const buttons = (
    <RBACWrapper requiredPermissions="manageReportRules">
      <s.ButtonWrapper>
        {/* <CSVLink
        data={currentData.data}
        // onClick={() => {
        //   if (confirm("Do you export data?")) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }}
        filename={currentData.fileName}
        > */}
        <BigButton
          label="Export"
          buttonType="cancel"
          onClickBtn={props.excelDownload}
          iconComponent={<EXPORT_ICON />}
          data-testid="reports-view-inventory-button-excel-download"
        />

        {/* </CSVLink> */}
        <BigButton
          label="Send Email"
          buttonType="cancel"
          onClickBtn={props.excelEmail}
          iconComponent={<SEND_EMAIL_ICON />}
          data-testid="reports-view-inventory-button-excel-email"
        />
      </s.ButtonWrapper>
    </RBACWrapper>
  );

  const titleComponent = [
    {
      label: "Report List",
      onClick: () => menuNavigation({ to: "/reports" }),
      //navigate(-1),
    },
    {
      label: props.title,
    },
  ];

  return (
    <>
      <TableTemplate
        buttons={buttons}
        titleComponent={titleComponent}
        onClickSearch={props.onClickSearch}
        requiredPermissions="manageReportRules"
      >
        <s.Container>
          <s.Header>
            <Tabs
              tabs={menus}
              currentTab={props.currentMenu}
              onChangeTab={(value) => props.onChange(value as INVENTORY_MENU)}
            />

            <mediaQuery.Default>
              <s.Status>
                <StatusLabel>
                  <StatusName>Recorders</StatusName>
                  <StatusValue>
                    {formatNumber(props.totalDataCount.recorder)}
                  </StatusValue>
                </StatusLabel>
                <StatusLabel>
                  <StatusName>Cameras</StatusName>
                  <StatusValue>
                    {formatNumber(props.totalDataCount.camera)}
                  </StatusValue>
                </StatusLabel>
              </s.Status>
            </mediaQuery.Default>
          </s.Header>
          {props.currentMenu === INVENTORY_MENU.RECORDER ? (
            <ExpandTableContainer>
              <CommonTable
                rowKey="mergedSystemId"
                columns={props.recorderColumns}
                dataSource={props.recorderData}
                queryInfo={props.recorderPaginationInfo}
                onChangePage={props.onChangePage}
                loading={props.recorderTablePending}
                expandable={props.expandableProps}
              />
            </ExpandTableContainer>
          ) : (
            <CommonTable
              columns={props.cameraColumns}
              dataSource={props.cameraData}
              queryInfo={props.cameraPaginationInfo}
              onChangePage={props.onChangePage}
              loading={props.cameraTablePending}
            />
          )}
        </s.Container>
        {props.isExportEmail && (
          <ExportMail
            reportId={props.reportId}
            title={props.title}
            onModal={props.onModalExportMail}
            recorderPaginationInfo={props.recorderPaginationInfo}
            cameraPaginationInfo={props.cameraPaginationInfo}
          />
        )}
      </TableTemplate>
      {props.AccountAccessModal}
    </>
  );
}
